module.exports = __webpack_public_path__ + "img/3ac39d8f679b4d2cb6bbaca5ebaaf588-1440.02b4c344.jpg";